import { Checkbox, TableCell } from '@mui/material';
import type React from 'react';
import type { toggleAllSelection } from '../../actions.js';

export type SelectAllHeaderCellProps = {
  readonly selectAll: string;
  readonly toggleAllSelection: ReturnType<typeof toggleAllSelection>;
};

const SelectAllHeaderCell: React.FC<SelectAllHeaderCellProps> = ({ selectAll, toggleAllSelection }) => {
  let checked = false;
  let indeterminate = false;
  if (selectAll === 'all') {
    checked = true;
    indeterminate = false;
  } else if (selectAll === 'some') {
    checked = true;
    indeterminate = true;
  }

  return (
    <TableCell padding="checkbox">
      <Checkbox checked={checked} onClick={toggleAllSelection} indeterminate={indeterminate} color="primary" />
    </TableCell>
  );
};

export default SelectAllHeaderCell;
